import { ClosingManager, SCM } from "utils/constants";

export const getVisitorCreatorRoleTitle = (item = {}) =>
  String(
    item?.lead_create_by_role ??
      item?.lead_create_by_role_title ??
      item?.role_name ??
      item?.created_by_role ??
      item?.created_by_role_title ??
      item?.created_by_role_name ??
      "",
  ).trim();

export const isVisitorCreatedByCmOrScm = (item = {}) => {
  const role = getVisitorCreatorRoleTitle(item).toLowerCase();
  if (role) {
    if (role.includes("closing manager")) return true;
    if (role === "scm" || role.includes("senior closing")) return true;
  }

  const creatorRoleId = String(
    item?.created_by_role_id ?? item?.create_by_role_id ?? "",
  ).trim();
  if (!creatorRoleId) return false;

  return (
    creatorRoleId === String(ClosingManager) ||
    creatorRoleId === String(SCM)
  );
};

/** Visitor already belongs to a CM/SCM (explicit allocation or CM/SCM-created). */
export const isVisitorAllocatedToCm = (item = {}) => {
  if (String(item?.for_cm_id || "").trim()) return true;
  return isVisitorCreatedByCmOrScm(item);
};

export const getVisitorCurrentCmId = (item = {}) => {
  const forCmId = String(item?.for_cm_id || "").trim();
  if (forCmId) return forCmId;
  if (isVisitorCreatedByCmOrScm(item)) {
    return String(item?.create_by || item?.created_by || "").trim();
  }
  return "";
};

export const getVisitorCurrentCmName = (item = {}) => {
  const allocatedName = String(item?.created_for_cm_name || "").trim();
  if (allocatedName) return allocatedName;
  if (isVisitorCreatedByCmOrScm(item)) {
    return String(item?.created_name || "").trim();
  }
  return "";
};

const getAppointmentAssignee = (item = {}) => {
  if (Array.isArray(item?.assign_appointment)) {
    return item.assign_appointment[0] || null;
  }
  return item?.assign_appointment || null;
};

const isCmOrScmAssigneeRole = (role = "") => {
  const normalized = String(role || "")
    .trim()
    .toLowerCase();
  if (!normalized) return true;
  return (
    normalized === "cm" ||
    normalized === "scm" ||
    normalized.includes("closing manager") ||
    normalized.includes("senior closing")
  );
};

/** Appointment row already assigned to a CM/SCM (lead or assign_appointment). */
export const isAppointmentAllocatedToCm = (item = {}) => {
  if (isVisitorAllocatedToCm(item)) return true;

  const assignee = getAppointmentAssignee(item);
  const userId = String(assignee?.user_id || "").trim();
  const userName = String(assignee?.user_name || "").trim();
  if (!userId && !userName) return false;

  return isCmOrScmAssigneeRole(assignee?.assign_by_role);
};

export const getAppointmentCurrentCmId = (item = {}) => {
  const fromLead = getVisitorCurrentCmId(item);
  if (fromLead) return fromLead;

  const assignee = getAppointmentAssignee(item);
  return String(assignee?.user_id || "").trim();
};

export const getAppointmentCurrentCmName = (item = {}) => {
  const fromLead = getVisitorCurrentCmName(item);
  if (fromLead) return fromLead;

  const assignee = getAppointmentAssignee(item);
  return String(assignee?.user_name || "").trim();
};
